import { makeActionHandler } from "./_reducerUtils";

const statusReducer = {
  initialState: {
    status: {
      list: [],
      isLoaded: false,
      isLoading: false,
      isQueryProcessing: false,
      isRefreshing: false,
      isDataOutdated: false,
      invalidationVersion: 0
    },
  },
  handlers: {
    "status/SET_LIST": makeActionHandler("status"),
    "RESET_ALL": () => statusReducer.initialState
  }
};

export default statusReducer;
